export function formatYikiCountdown(remainingTime) {
  if (!remainingTime) return '--:--:--';
  const { days, hours, minutes, seconds } = remainingTime;
  if (days > 0) {
    return `${days}ว ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export const YIKI_BET_TYPES = {
  TWO: 'two',
  THREE: 'three',
};

export const YIKI_BET_TYPE_LABELS = {
  two: '2 ตัวท้าย',
  three: '3 ตัวตรง',
};

/** $50 ต่อ $1 (x50) */
export function formatYikiPayout(multiplier) {
  return `$${multiplier} ต่อ $1 (x${multiplier})`;
}

/** $50–$95 ต่อ $1 (x50–x95) */
export function formatYikiPayoutRange(min, max) {
  return `$${min}–$${max} ต่อ $1 (x${min}–x${max})`;
}
